import styled from 'styled-components'

import Avatar from 'components/Avatar'
import Box from 'components/Box'
import Icon from 'components/Icon'
import Text from 'components/Text'
import Skeleton from 'components/SkeletonLoader'

import { DateWithToolTip } from 'components'

export type Props = {
  avatarName: string
  imageSource?: string
  isLoading?: boolean
  activityTitle: string
  timeStamp: Date | string
}

const CardHeader = ({ avatarName = '', imageSource, isLoading = false, activityTitle, timeStamp }: Props) => (
  <Box display="flex" alignItems="center">
    {isLoading && (
      <>
        <Skeleton circle height="20px" mr={16} width="20px" />
        <Skeleton height="16px" width="234px" />
      </>
    )}
    {!isLoading && (
      <>
        <Avatar label={avatarName} placeholder={avatarName} imgSrc={imageSource} size="xsmall" />
        <StyledText color="gray7" fontWeight="medium">
          {avatarName}
        </StyledText>
        <StyledText color="gray5">{activityTitle}</StyledText>
        <StyledIcon ml="5px" icon={['fas', 'circle']} color="gray4" />
        <StyledText color="gray5">
          <DateWithToolTip date={timeStamp.toString()} />
        </StyledText>
      </>
    )}
  </Box>
)

const StyledText = styled(Text)`
  font-size: 13px;
  line-height: 24px;
  margin-left: 5px;
`

const StyledIcon = styled(Icon)`
  font-size: 5px;
`

export default CardHeader
